import { render, staticRenderFns } from "./code-of-conduct-edit.vue?vue&type=template&id=06c728e4&scoped=true"
import script from "./code-of-conduct-edit.vue?vue&type=script&lang=js"
export * from "./code-of-conduct-edit.vue?vue&type=script&lang=js"
import style0 from "./code-of-conduct-edit.vue?vue&type=style&index=0&id=06c728e4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c728e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c728e4')) {
      api.createRecord('06c728e4', component.options)
    } else {
      api.reload('06c728e4', component.options)
    }
    module.hot.accept("./code-of-conduct-edit.vue?vue&type=template&id=06c728e4&scoped=true", function () {
      api.rerender('06c728e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/edit-poppers/code-of-conduct-edit.vue"
export default component.exports